import { SP360IconLogo } from 'assets';
import callApi from 'lib/callApi';
import QRCode from 'qrcode.react';
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardText,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

import history from '../history';

export const AuthenticationMethod = {
  Email: 'email',
  TOTP: 'totp',
};

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      username: '',
      password: '',
      url: undefined,
      otp: '',
      mfaModal: false,
      password_verified: false,
      authentication_method: '',
      confirmationModal: false,
      openNotificationModal: false,
    };
  }
  componentDidMount() {
    this.fetchProfile.bind(this)();
  }

  async verifyOTP() {
    let url = `profiles/verify-totp-code/`;
    await callApi(url, 'POST', {}, { otp: this.state.otp })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          this.updateProfile();
          this.setState({ mfaModal: false });
        } else {
          console.error({
            function: 'verifyOTP',
            error: `Unexpected response: ${res.status}`,
            res,
          });
        }
      })
      .catch((err) => {
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
          console.error(res);
          toast.error('Entered OTP code is invalid');
        }
      });
  }

  async fetchProfile(currentUrl) {
    let url = `profiles/`;
    if (currentUrl) {
      url = currentUrl;
    }
    await callApi(url, 'GET', {})
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data.results) {
            let user = {};
            if (res.data.count === 1 || res.data.count === '1') {
              user = res.data.results[0];
            }
            this.setState({
              profile: res.data.results,
              user: user,
              authentication_method: user.authentication_method,
              count: res.data.count,
              nextUrl: res.data.next,
              previousUrl: res.data.previous,
            });
          } else {
            this.setState({ profile: [], count: 0 });
          }
          this.setState({ modal: false });
        } else if (res.status === 401 || res.status === 400) {
          history.push('/login');
        }
      })
      .catch((err) => {
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
          history.push('/login');
        }
      });
  }
  updateUserData(field, value) {
    let user = this.state.user;
    user[field] = value;
    this.setState({ user: user });
  }

  async updateProfile() {
    let url = `profiles/${this.state.user.value}/`;
    await callApi(url, 'PUT', {}, this.state.user)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          this.setState({ user: res.data });
          toast.success('Your profile has been successfully updated.', {});
        } else if (res.status === 422) {
          toast.error('Error! ' + res.data, {});
        } else if (res.status === 401 || res.status === 400) {
          history.push('/login');
        }
      })
      .catch((err) => {
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
          toast.error('Error! ' + res.data.detail, {});
          history.push('/login');
        }
      });
    this.setState({
      authentication_method: this.state.user.authentication_method,
      confirmationModal: false,
    });
  }

  renderUpdateMFAMethods() {
    return (
      <>
        {this.state.mfaModal && (
          <Modal isOpen={this.state.mfaModal} size="md">
            <ModalHeader>
              {this.state.password_verified
                ? 'Set up authenticator app'
                : 'Confirm?'}
            </ModalHeader>
            <ModalBody>
              {this.state.password_verified &&
                this.state.user.totp_device_configured === true && (
                  <>
                    <p>
                      You have already configured an authenticator app for the
                      backend application. Please confirm whether you would like
                      to use the same app for this application?
                    </p>
                  </>
                )}

              {this.state.password_verified &&
                this.state.user.totp_device_configured === false && (
                  <>
                    <ul>
                      <li>
                        In the authenticator app tap the <strong>+</strong>
                      </li>
                      <li>
                        Choose <strong>Scan a QR Code</strong>
                      </li>
                    </ul>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <QRCode
                        value={this.state.url}
                        size={150}
                        style={{ margin: 'auto' }}
                      />
                    </div>
                    <FormGroup>
                      <p>Enter the 6-digit code you see in the app </p>
                      <Input
                        name="otp"
                        maxLength={6}
                        onChange={(event) =>
                          this.setState({ otp: event.target.value })
                        }
                        placeholder="OTP code"
                        type="text"
                      />
                    </FormGroup>
                  </>
                )}

              {this.state.password_verified === false && (
                <>{this.renderUserPasswordForm()}</>
              )}
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                size="sm"
                onClick={() => {
                  this.setState({ mfaModal: false });
                  if (
                    this.state.user.authentication_method ===
                    AuthenticationMethod.Email
                  ) {
                    this.updateUserData(
                      'authentication_method',
                      AuthenticationMethod.TOTP,
                    );
                  } else {
                    this.updateUserData(
                      'authentication_method',
                      AuthenticationMethod.Email,
                    );
                  }
                }}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                size="sm"
                onClick={async () => {
                  if (
                    this.state.password_verified &&
                    this.state.user.totp_device_configured === false
                  ) {
                    this.verifyOTP.bind(this)();
                  } else if (
                    this.state.password_verified &&
                    this.state.user.totp_device_configured === true
                  ) {
                    this.setState({ mfaModal: false });
                    this.updateProfile.bind(this)();
                  } else {
                    await callApi(
                      `profiles/validate-user-credentials/`,
                      'POST',
                      {},
                      {
                        username: this.state.username,
                        password: this.state.password,
                        authentication_method:
                          this.state.user.authentication_method,
                      },
                    )
                      .then((res) => {
                        if (res.status === 201 || res.status === 200) {
                          if (
                            this.state.user.authentication_method ===
                            AuthenticationMethod.Email
                          ) {
                            this.setState({ mfaModal: false });
                            this.updateProfile.bind(this)();
                          } else {
                            this.setState({ password_verified: true });
                            if (
                              this.state.user.totp_device_configured === false
                            ) {
                              this.setState({ url: res.data.url });
                            }
                          }
                        }
                      })
                      .catch((err) => {
                        toast.error('Username or password incorrect');
                      });
                  }
                }}
              >
                Confirm
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </>
    );
  }

  renderUserPasswordForm() {
    return (
      <>
        <p>
          Please provide your login credentials to confirm the change of your
          2FA (MFA) authentication method:
        </p>
        <FormGroup>
          <p>Username</p>
          <Input
            name="username"
            onChange={(event) =>
              this.setState({ username: event.target.value })
            }
            placeholder="Username"
            type="text"
          />
          <p>Password</p>
          <Input
            name="password"
            onChange={(event) =>
              this.setState({ password: event.target.value })
            }
            placeholder="Password"
            type="password"
            autoComplete="new-password"
          />
        </FormGroup>
      </>
    );
  }

  renderNotification() {
    return (
      <>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    );
  }

  render() {
    return (
      <>
        <div className="content">
          <Row>
            <Col md="8">
              <Card>
                <CardHeader>
                  <h5 className="title">Edit Profile</h5>
                </CardHeader>
                <CardBody>
                  <Form>
                    <Row>
                      <Col className="pr-md-1" md="8">
                        <FormGroup>
                          <label>Company </label>
                          <Input
                            name="company"
                            defaultValue={this.state.user.company_name}
                            onChange={(event) =>
                              this.updateUserData(
                                'company_name',
                                event.target.value,
                              )
                            }
                            placeholder="Company"
                            type="text"
                            maxLength={100}
                          />
                        </FormGroup>
                      </Col>

                      <Col className="pl-md-1" md="4">
                        <FormGroup>
                          <label htmlFor="exampleInputEmail1">
                            Email address
                          </label>
                          <Input
                            name="email"
                            disabled
                            maxLength={100}
                            defaultValue={this.state.user.email}
                            placeholder="mike@email.com"
                            type="email"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-md-1" md="6">
                        <FormGroup>
                          <label>First Name</label>
                          <Input
                            name="first_name"
                            maxLength={30}
                            defaultValue={this.state.user.first_name}
                            onChange={(event) =>
                              this.updateUserData(
                                'first_name',
                                event.target.value,
                              )
                            }
                            placeholder="First Name"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pl-md-1" md="6">
                        <FormGroup>
                          <label>Last Name</label>
                          <Input
                            name="last_name"
                            maxLength={30}
                            defaultValue={this.state.user.last_name}
                            onChange={(event) =>
                              this.updateUserData(
                                'last_name',
                                event.target.value,
                              )
                            }
                            placeholder="Last Name"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
                <CardHeader>
                  <h5 className="title">MFA Authentication</h5>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col className="pr-md-1" md="4">
                      <FormGroup>
                        <label>
                          Select desired 2FA(MFA) authentication method
                        </label>
                        <Input
                          type="select"
                          value={this.state.user.authentication_method}
                          onChange={(event) => {
                            this.updateUserData(
                              'authentication_method',
                              event.target.value,
                            );
                            this.setState({
                              mfaModal: true,
                              password_verified: false,
                            });
                          }}
                        >
                          <option
                            style={{ color: 'black', backgroundColor: 'white' }}
                            value={AuthenticationMethod.Email}
                          >
                            via Email
                          </option>
                          <option
                            style={{ color: 'black', backgroundColor: 'white' }}
                            value={AuthenticationMethod.TOTP}
                          >
                            via Authenticator App
                          </option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-md-1" md="8">
                      <FormGroup>
                        {this.state.user.authentication_method ===
                          AuthenticationMethod.Email && (
                          <>
                            <p>
                              When logging on, the MFA code will be sent to your
                              email address:{' '}
                              <strong>{this.state.user.email}</strong>
                            </p>
                          </>
                        )}
                        {this.state.user.authentication_method ===
                          AuthenticationMethod.TOTP && (
                          <>
                            <p>Use your phone as your second step to sign in</p>
                          </>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <Button
                    className="btn-fill"
                    color="primary"
                    type="submit"
                    onClick={this.updateProfile.bind(this)}
                  >
                    Save
                  </Button>
                </CardFooter>
              </Card>
            </Col>
            <Col md="4">
              <Card className="card-user">
                <CardBody>
                  <CardText />
                  <div className="author">
                    <div className="block block-one" />
                    <div className="block block-two" />
                    <div className="block block-three" />
                    <div className="block block-four" />
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img alt="..." className="avatar" src={SP360IconLogo} />
                      <h5 className="title">
                        {this.state.user.first_name} {this.state.user.last_name}
                      </h5>
                    </a>
                    <p className="description">{this.state.user.position}</p>
                  </div>
                  <div className="card-description"></div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        {this.renderUpdateMFAMethods()}
        {this.renderNotification()}
      </>
    );
  }
}

export default UserProfile;
